import { Field } from 'react-final-form';

import { type TranslatedComponent, translation } from '@hh.ru/front-static-app';
import { Cell, CellText, Checkbox } from '@hh.ru/magritte-ui';

import type { ApplicantLoginFormValues } from 'src/components/AccountLogin/CombinedLoginCards/ApplicantLoginCard/MultiStepForm/types';
import { TRUST_THIS_SOURCE_FIELD } from 'src/components/AccountLogin/CombinedLoginCards/ApplicantLoginCard/MultiStepForm/utils';

const TrlKeys = {
    label: 'auth.twoFactor.totp.trustThisSource',
};

const TrustThisSourceField: TranslatedComponent = ({ trls }) => {
    return (
        <Field<ApplicantLoginFormValues['trust_this_source']>
            name={TRUST_THIS_SOURCE_FIELD}
            type="checkbox"
            render={({ input }) => {
                return (
                    <Cell left={<Checkbox {...input} value={String(input.value)} />}>
                        <CellText>{trls[TrlKeys.label]}</CellText>
                    </Cell>
                );
            }}
        />
    );
};

export default translation(TrustThisSourceField);
